function cov_2ogpp7saxb() {
  var path = "/app/src/components/default-promo-widget/components/non-ltf-snippet/non-ltf-snippet.tsx";
  var hash = "3c42d30b446c1167040fc10b536a154644909ee0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/default-promo-widget/components/non-ltf-snippet/non-ltf-snippet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 27
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 48
        }
      },
      "2": {
        start: {
          line: 19,
          column: 29
        },
        end: {
          line: 87,
          column: 1
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 19
        }
      },
      "4": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 23,
          column: 23
        }
      },
      "5": {
        start: {
          line: 25,
          column: 20
        },
        end: {
          line: 25,
          column: 71
        }
      },
      "6": {
        start: {
          line: 26,
          column: 16
        },
        end: {
          line: 26,
          column: 54
        }
      },
      "7": {
        start: {
          line: 28,
          column: 17
        },
        end: {
          line: 31,
          column: 4
        }
      },
      "8": {
        start: {
          line: 28,
          column: 40
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "9": {
        start: {
          line: 33,
          column: 24
        },
        end: {
          line: 36,
          column: 13
        }
      },
      "10": {
        start: {
          line: 38,
          column: 18
        },
        end: {
          line: 68,
          column: 3
        }
      },
      "11": {
        start: {
          line: 39,
          column: 24
        },
        end: {
          line: 39,
          column: 72
        }
      },
      "12": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "13": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 51,
          column: 10
        }
      },
      "14": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 61,
          column: 10
        }
      },
      "15": {
        start: {
          line: 56,
          column: 30
        },
        end: {
          line: 56,
          column: 62
        }
      },
      "16": {
        start: {
          line: 57,
          column: 34
        },
        end: {
          line: 57,
          column: 59
        }
      },
      "17": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 66,
          column: 11
        }
      },
      "18": {
        start: {
          line: 64,
          column: 26
        },
        end: {
          line: 64,
          column: 58
        }
      },
      "19": {
        start: {
          line: 65,
          column: 30
        },
        end: {
          line: 65,
          column: 55
        }
      },
      "20": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 86,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 48
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 29
          },
          end: {
            line: 19,
            column: 30
          }
        },
        loc: {
          start: {
            line: 19,
            column: 53
          },
          end: {
            line: 87,
            column: 1
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 17
          },
          end: {
            line: 28,
            column: 18
          }
        },
        loc: {
          start: {
            line: 28,
            column: 40
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 28
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 38,
            column: 19
          }
        },
        loc: {
          start: {
            line: 38,
            column: 46
          },
          end: {
            line: 68,
            column: 3
          }
        },
        line: 38
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 56,
            column: 24
          },
          end: {
            line: 56,
            column: 25
          }
        },
        loc: {
          start: {
            line: 56,
            column: 30
          },
          end: {
            line: 56,
            column: 62
          }
        },
        line: 56
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 57,
            column: 22
          },
          end: {
            line: 57,
            column: 23
          }
        },
        loc: {
          start: {
            line: 57,
            column: 34
          },
          end: {
            line: 57,
            column: 59
          }
        },
        line: 57
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 64,
            column: 20
          },
          end: {
            line: 64,
            column: 21
          }
        },
        loc: {
          start: {
            line: 64,
            column: 26
          },
          end: {
            line: 64,
            column: 58
          }
        },
        line: 64
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 65,
            column: 18
          },
          end: {
            line: 65,
            column: 19
          }
        },
        loc: {
          start: {
            line: 65,
            column: 30
          },
          end: {
            line: 65,
            column: 55
          }
        },
        line: 65
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 39,
            column: 24
          },
          end: {
            line: 39,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 39,
            column: 32
          },
          end: {
            line: 39,
            column: 67
          }
        }, {
          start: {
            line: 39,
            column: 70
          },
          end: {
            line: 39,
            column: 72
          }
        }],
        line: 39
      },
      "1": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 51,
            column: 10
          }
        }, {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 61,
            column: 10
          }
        }, {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 66,
            column: 11
          }
        }],
        line: 41
      },
      "2": {
        loc: {
          start: {
            line: 42,
            column: 11
          },
          end: {
            line: 42,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 11
          },
          end: {
            line: 42,
            column: 25
          }
        }, {
          start: {
            line: 42,
            column: 29
          },
          end: {
            line: 42,
            column: 47
          }
        }],
        line: 42
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3c42d30b446c1167040fc10b536a154644909ee0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ogpp7saxb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ogpp7saxb();
import React from 'react';
import { lazily } from 'react-lazily';
import NumberFormat from 'react-number-format';
import { Currency } from 'src/components/currency';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';
import { CurrencyType } from 'src/types/currency';
import { createNormalizeCheckingNumber } from 'src/utils/create-normalize-checking-number';
import { getPriceSplitOf } from 'src/utils/get-price-split-of';
var _ref = (cov_2ogpp7saxb().s[0]++, lazily(function () {
    cov_2ogpp7saxb().f[0]++;
    cov_2ogpp7saxb().s[1]++;
    return import('src/components/snippet-default');
  })),
  SnippetDefault = _ref.SnippetDefault;
cov_2ogpp7saxb().s[2]++;
export var NonLtfSnippet = function NonLtfSnippet(_ref2) {
  var onClick = _ref2.onClick;
  cov_2ogpp7saxb().f[1]++;
  var _ref3 = (cov_2ogpp7saxb().s[3]++, useAppContext()),
    _currency = _ref3.currency,
    price = _ref3.price,
    installmentsCount = _ref3.installmentsCount,
    formattedCurrency = _ref3.formattedCurrency,
    priceRaw = _ref3.priceRaw;
  var t = (cov_2ogpp7saxb().s[4]++, useLocale());
  var pricePart = (cov_2ogpp7saxb().s[5]++, getPriceSplitOf(price, _currency, installmentsCount));
  var isKSA = (cov_2ogpp7saxb().s[6]++, formattedCurrency === CurrencyType.SAR);
  cov_2ogpp7saxb().s[7]++;
  var params = function params(newPrice) {
    cov_2ogpp7saxb().f[2]++;
    cov_2ogpp7saxb().s[8]++;
    return {
      price: newPrice,
      installmentsCount: installmentsCount
    };
  };
  var preparedPrice = (cov_2ogpp7saxb().s[9]++, createNormalizeCheckingNumber('Price argument is not a number', 0)(priceRaw));
  cov_2ogpp7saxb().s[10]++;
  var getText = function getText(formattedValue) {
    cov_2ogpp7saxb().f[3]++;
    var shariahText = (cov_2ogpp7saxb().s[11]++, isKSA ? (cov_2ogpp7saxb().b[0][0]++, "".concat(t('default.shariahCompliant'), ".")) : (cov_2ogpp7saxb().b[0][1]++, ''));
    cov_2ogpp7saxb().s[12]++;
    switch (true) {
      case (cov_2ogpp7saxb().b[2][0]++, !preparedPrice) || (cov_2ogpp7saxb().b[2][1]++, !installmentsCount):
        cov_2ogpp7saxb().b[1][0]++;
        cov_2ogpp7saxb().s[13]++;
        return /*#__PURE__*/React.createElement(React.Fragment, null, t('default.split_your_purchases_interest_free', {
          installmentsCount: installmentsCount
        }), '. ', shariahText);
      case isKSA:
        cov_2ogpp7saxb().b[1][1]++;
        cov_2ogpp7saxb().s[14]++;
        return /*#__PURE__*/React.createElement(React.Fragment, null, t('n_interest_free_payments', params(formattedValue), {
          currency: function currency() {
            cov_2ogpp7saxb().f[4]++;
            cov_2ogpp7saxb().s[15]++;
            return /*#__PURE__*/React.createElement(Currency, {
              currency: _currency
            });
          },
          strong: function strong(string) {
            cov_2ogpp7saxb().f[5]++;
            cov_2ogpp7saxb().s[16]++;
            return /*#__PURE__*/React.createElement("strong", null, string);
          }
        }), ' ', shariahText);
      default:
        cov_2ogpp7saxb().b[1][2]++;
        cov_2ogpp7saxb().s[17]++;
        return t('n_interest_free_payments', params(formattedValue), {
          currency: function currency() {
            cov_2ogpp7saxb().f[6]++;
            cov_2ogpp7saxb().s[18]++;
            return /*#__PURE__*/React.createElement(Currency, {
              currency: _currency
            });
          },
          strong: function strong(string) {
            cov_2ogpp7saxb().f[7]++;
            cov_2ogpp7saxb().s[19]++;
            return /*#__PURE__*/React.createElement("strong", null, string);
          }
        });
    }
  };
  cov_2ogpp7saxb().s[20]++;
  return /*#__PURE__*/React.createElement(SnippetDefault, {
    message: /*#__PURE__*/React.createElement(NumberFormat
    /* Need key to recall renderText with new pricePart */, {
      thousandSeparator: ",",
      key: pricePart,
      value: pricePart,
      renderText: getText,
      displayType: "text",
      allowNegative: false
    }),
    linkText: t('default.learnMore'),
    onClick: onClick
  });
};